import { getSkillRatio, getFlatSkillBonus } from './skillMod'
import * as Calc from './formulas'
import * as battleOption from './battleOptions'
import { defaultValue } from './entity'
import SkillOption from '../data/skill_db.json'

export function getBattleDamage(
	baseDamage,
	source,
	target,
	skillName,
	skillLv,
) {
	let finalDamage = baseDamage
	if (battleOption.doesSkillUseMastery(skillName, skillLv)) {
		finalDamage += defaultValue(source?.Bonuses?.bMastery, 0)
	}
	if (battleOption.isSkillMagic(skillName)) {
		// Magic skills are neither ranged nor close-range: the physical
		// bLongAtkRate / bShortAtkRate modifiers don't apply to them.
	} else if (
		battleOption.isSkillRanged(skillName, skillLv) ||
		battleOption.isWeaponRanged(source?.Inventory?.Right_Hand?.SubType)
	)
		finalDamage = Math.floor(
			finalDamage *
				(1 +
					(source?.Bonuses['bLongAtkRate']
						? source?.Bonuses['bLongAtkRate']
						: 0) /
						100),
		)
	else {
		// console.log(source)
		finalDamage = Math.floor(
			finalDamage *
				(1 +
					(source?.Bonuses['bShortAtkRate']
						? source?.Bonuses['bShortAtkRate']
						: 0) /
						100),
		)
	}
	finalDamage = applySkillRatio(
		finalDamage,
		getSkillRatio(
			{ miscflag: defaultValue(source?.Bonuses?.bMiscflag, 0) },
			skillName,
			skillLv,
			source,
			target,
		),
	)
	//console.log(source)
	if (
		SkillOption.find((skill) => skill.Name === skillName)?.type !== 'Magic'
	) {
		if (!ignoresTargetDef(source, target)) {
			// bIgnoreDefRace / bIgnoreDefClass (e.g. Union buff, or item scripts) fully
			// bypass the target's DEF for matching races/classes (RC_All / Class_All = all).
			if (skillName !== 'MO_EXTREMITYFIST')
				finalDamage = applyHardDef(
					finalDamage,
					Calc.getDefReduction(source, target),
				)
			else finalDamage = applySoftDef(finalDamage, target.Defense)
			finalDamage = applySoftDef(finalDamage, target.SoftDefense)
		}
	} else if (!ignoresTargeMdef(source, target)) {
		finalDamage = applyHardDef(
			finalDamage,
			Calc.getMdefReduction(source, target),
		)
		finalDamage = applySoftDef(finalDamage, target.SoftMagicDefense)
	}

	//Bonus type Skill damage + X %
	finalDamage = applyBonusSkillDamage(
		finalDamage,
		battleOption.getSkillDamageMultiplier(source?.Bonuses, skillName),
	)

	finalDamage += getFlatSkillBonus(0, source, target, skillName, skillLv)
	return Math.max(finalDamage, 1)
}

function applySkillRatio(damage, ratio) {
	return Math.floor((damage * ratio) / 100)
}
// True if the source disregards the target's DEF (bIgnoreDefRace/bIgnoreDefClass).
// Stored like item scripts: arrays of { Class: <RC_*/Class_*> }; RC_All / Class_All
// match every enemy.
function ignoresTargetDef(source, target) {
	const raceList = source?.Bonuses?.bIgnoreDefRace || []
	const classList = source?.Bonuses?.bIgnoreDefClass || []
	const raceKey =
		'RC_' + (target?.Race === 'Demihuman' ? 'DemiHuman' : target?.Race)
	return (
		raceList.some((e) => e.Class === 'RC_All' || e.Class === raceKey) ||
		classList.some((e) => e.Class === 'Class_All')
	)
}
// True if the source disregards the target's DEF (bIgnoreDefRace/bIgnoreDefClass).
// Stored like item scripts: arrays of { Class: <RC_*/Class_*> }; RC_All / Class_All
// match every enemy.
function ignoresTargeMdef(source, target) {
	const raceList = source?.Bonuses?.bIgnoreMdefRace || []
	const classList = source?.Bonuses?.bIgnoreMdefRace || []
	const raceKey =
		'RC_' + (target?.Race === 'Demihuman' ? 'DemiHuman' : target?.Race)
	return (
		raceList.some((e) => e.Class === 'RC_All' || e.Class === raceKey) ||
		classList.some((e) => e.Class === 'Class_All')
	)
}

function applyHardDef(damage, defRatio) {
	return Math.floor(damage * defRatio)
}
function applySoftDef(damage, softDef) {
	return damage - softDef
}
function applyBonusSkillDamage(damage, bonus) {
	return Math.floor(damage * (1 + bonus / 100))
}
